export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["При завершении сделки она будет закрыта. Внутренние средства будут переведены пользователю."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы уверены, что хотите завершить сделку?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Да, завершить"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет, оставить активной"])}
}